export const mfrFacilityTypeOptions = [
    { val: 'BL', lbl: 'Black Lung Clinics Program' },
    { val: 'PED', lbl: 'Childrens Hospital' },
    { val: 'HM', lbl: 'Comprehensive Hemophilia Treatment Center' },
    { val: 'CH', lbl: 'Consolidated Health Center Program' },
    { val: 'CAH', lbl: 'Critical Access Hospital' },
    { val: 'DSH', lbl: 'Disproportionate Share Hospital' },
    { val: 'FP', lbl: 'Family Planning (Title X only)' },
    { val: 'FQHCLA', lbl: 'Federally Qualified Health Center Look-Alike' },
    { val: 'CAN', lbl: 'Free Standing Cancer Hospital' },
    { val: 'HO', lbl: 'Health Care for the Homeless Program' },
    { val: 'MH', lbl: 'Migrant Health Program' },
    { val: 'NH', lbl: 'Native Hawaiian Health Care Program' },
    { val: 'PH', lbl: 'Public Housing Primary Care Program' },
    { val: 'RRC', lbl: 'Rural Referral Center' },
    { val: 'RWI', lbl: 'Ryan White Part A' },
    { val: 'RWII', lbl: 'Ryan White Part B' },
    { val: 'RWIID', lbl: 'Ryan White Part B ADAP Direct Purchase' },
    { val: 'RWIIR', lbl: 'Ryan White Part B ADAP Rebate Option' },
    { val: 'HV', lbl: 'Ryan White Part C' },
    { val: 'RW4', lbl: 'Ryan White Part D' },
    { val: 'SPNS', lbl: 'Ryan White Part F' },
    { val: '340S', lbl: 'School Based Program (Healthy Schools, Healthy Communities)' },
    { val: 'STD', lbl: 'Sexually Transmitted Diseases' },
    { val: 'SCH', lbl: 'Sole Community Hospital' },
    { val: 'FQHC638', lbl: 'Tribal Contract/Compact with IHS (P.L. 93-638)' },
    { val: 'TB', lbl: 'Tuberculosis' },
    { val: 'UI', lbl: 'Urban Indian' },
];
